import TpJobAdmin from './TpJobAdmin';

export default class ExcludedTpJobsAdmin extends TpJobAdmin {}
